import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, isNull } from 'lodash';

import { PATH } from '../../../constants/path';
import { COIN_NAME, HAS_INSTANT_DISCOUNT, USE_PARITY } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import { getI18nByApp } from '../../../services/i18n/selector';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import CustomerServiceComponent from '../../CustomerServiceComponent';

import { HowItWorksPageContainer } from './HowItWorksPageStyle';

export class HowItWorksPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    getLabelText() {
        const { i18n } = this.props;
        switch (true) {
            case USE_PARITY:
                return convertHtmlToReactDomWithParams(
                    getI18nByApp(i18n, 'page.HOW_IT_WORKS.TEXT2_PARITY_DISCOUNT'),
                    COIN_NAME
                );
            case HAS_INSTANT_DISCOUNT:
                return convertHtmlToReactDomWithParams(
                    getI18nByApp(i18n, 'page.HOW_IT_WORKS.TEXT2_INSTANT_DISCOUNT')
                );
            default:
                return convertHtmlToReactDomWithParams(
                    getI18nByApp(i18n, 'page.HOW_IT_WORKS.TEXT2_CASHBACK_DISCOUNT')
                );
        }
    }

    render() {
        const { i18n, faqData } = this.props;

        // Currently select the first theme with non empty faq list /!\
        const theme = faqData.find(e => !isEmpty(e.faqs)) || null;

        return (
            <React.Fragment>
                <HowItWorksPageContainer className="conteneur conteneur-mobile">
                    <HeadComponent
                        title={getI18nByApp(i18n, 'page.HOW_IT_WORKS.TITLE')}
                        description={getI18nByApp(i18n, 'page.HOW_IT_WORKS.DESCRIPTION')}
                    />
                    <LocalizedBreadcrumbItem to={PATH.HOW_IT_WORKS}>
                        {getI18nByApp(i18n, 'page.HOW_IT_WORKS.BREADCRUMB')}
                    </LocalizedBreadcrumbItem>
                    <h1>{getI18nByApp(i18n, 'page.HOW_IT_WORKS.TITLE')}</h1>

                    <HowItWorksComponent showButtons noPadding />

                    <hr />
                    <div className="ccm-text">
                        <h3>{getI18nByApp(i18n, 'page.HOW_IT_WORKS.TITLE1')}</h3>
                        <p>
                            {USE_PARITY
                                ? convertHtmlToReactDomWithParams(
                                      getI18nByApp(i18n, 'page.HOW_IT_WORKS.TEXT1_PARITY_DISCOUNT'),
                                      COIN_NAME
                                  )
                                : HAS_INSTANT_DISCOUNT
                                ? convertHtmlToReactDomWithParams(
                                      getI18nByApp(i18n, 'page.HOW_IT_WORKS.TEXT1_INSTANT_DISCOUNT')
                                  )
                                : convertHtmlToReactDomWithParams(
                                      getI18nByApp(
                                          i18n,
                                          'page.HOW_IT_WORKS.TEXT1_CASHBACK_DISCOUNT'
                                      )
                                  )}
                        </p>
                        <p>{this.getLabelText()}</p>
                    </div>
                    <hr />

                    <div className="help-container grid">
                        <div className="faq-container inbl">
                            <div className="faq-bandeau">
                                {getI18nByApp(i18n, 'page.HOW_IT_WORKS.QUESTION')}
                            </div>
                            <div className="faq-list-container">
                                {!isNull(theme) &&
                                    theme.faqs
                                        .slice(0, 4)
                                        .map(faq => (
                                            <FaqElementComponent
                                                key={faq.id}
                                                faq={faq}
                                                cssClass="question-comment-ca-marche-page"
                                                forceArrowRight
                                                linkToFaqPage
                                            />
                                        ))}
                            </div>
                        </div>

                        <CustomerServiceComponent />
                    </div>
                </HowItWorksPageContainer>
            </React.Fragment>
        );
    }
}

HowItWorksPage.propTypes = {
    i18n: PropTypes.object.isRequired,
    faqData: PropTypes.array
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18n: state.i18n,
        faqData: state.faq.faqs || []
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HowItWorksPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/HowItWorksPage.js